/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierClaimNoticeState } from "./CarrierClaimNoticeState";
import {
  CarrierClaimNoticeStateFromJSON,
  CarrierClaimNoticeStateFromJSONTyped,
  CarrierClaimNoticeStateToJSON,
  CarrierClaimNoticeStateToJSONTyped,
} from "./CarrierClaimNoticeState";
import type { CarrierClaimNoticeTrigger } from "./CarrierClaimNoticeTrigger";
import {
  CarrierClaimNoticeTriggerFromJSON,
  CarrierClaimNoticeTriggerFromJSONTyped,
  CarrierClaimNoticeTriggerToJSON,
  CarrierClaimNoticeTriggerToJSONTyped,
} from "./CarrierClaimNoticeTrigger";

/**
 *
 * @export
 * @interface CarrierClaimNotice
 */
export interface CarrierClaimNotice {
  /**
   *
   * @type {string}
   * @memberof CarrierClaimNotice
   */
  carrierClaimNoticeId?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierClaimNotice
   */
  shipmentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierClaimNotice
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {CarrierClaimNoticeState}
   * @memberof CarrierClaimNotice
   */
  state?: CarrierClaimNoticeState;
  /**
   *
   * @type {CarrierClaimNoticeTrigger}
   * @memberof CarrierClaimNotice
   */
  triggeredBy?: CarrierClaimNoticeTrigger;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierClaimNotice
   */
  sentAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CarrierClaimNotice
   */
  sentBy?: string;
  /**
   *
   * @type {string}
   * @memberof CarrierClaimNotice
   */
  frontConversationId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierClaimNotice
   */
  acknowledgedAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CarrierClaimNotice interface.
 */
export function instanceOfCarrierClaimNotice(
  value: object,
): value is CarrierClaimNotice {
  return true;
}

export function CarrierClaimNoticeFromJSON(json: any): CarrierClaimNotice {
  return CarrierClaimNoticeFromJSONTyped(json, false);
}

export function CarrierClaimNoticeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierClaimNotice {
  if (json == null) {
    return json;
  }
  return {
    carrierClaimNoticeId:
      json["carrierClaimNoticeId"] == null
        ? undefined
        : json["carrierClaimNoticeId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    state:
      json["state"] == null
        ? undefined
        : CarrierClaimNoticeStateFromJSON(json["state"]),
    triggeredBy:
      json["triggeredBy"] == null
        ? undefined
        : CarrierClaimNoticeTriggerFromJSON(json["triggeredBy"]),
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    sentBy: json["sentBy"] == null ? undefined : json["sentBy"],
    frontConversationId:
      json["frontConversationId"] == null
        ? undefined
        : json["frontConversationId"],
    acknowledgedAt:
      json["acknowledgedAt"] == null ? undefined : json["acknowledgedAt"],
  };
}

export function CarrierClaimNoticeToJSON(json: any): CarrierClaimNotice {
  return CarrierClaimNoticeToJSONTyped(json, false);
}

export function CarrierClaimNoticeToJSONTyped(
  value?: CarrierClaimNotice | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierClaimNoticeId: value["carrierClaimNoticeId"],
    shipmentId: value["shipmentId"],
    createdAt: value["createdAt"],
    state: CarrierClaimNoticeStateToJSON(value["state"]),
    triggeredBy: CarrierClaimNoticeTriggerToJSON(value["triggeredBy"]),
    sentAt: value["sentAt"],
    sentBy: value["sentBy"],
    frontConversationId: value["frontConversationId"],
    acknowledgedAt: value["acknowledgedAt"],
  };
}
